<script>
import {
    ArrowUpIcon
} from 'vue-feather-icons';

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";

/**
 * Page-blog-list component
 */
export default {
    data() {
        return {}
    },
    components: {
        Navbar,
        Switcher,
        Footer,
        ArrowUpIcon
    },
  methods: {
      onPay() {
        this.$bvModal.show("pay-modal");
      }
  }
}
</script>

<template>
<div>
    <Navbar />

  <b-modal id="pay-modal" size="lg" ref="pay-modal"
           hide-footer
           title="请使用手机扫码支付"
           centered>

    <img src="images/pay.png" class="img-fluid" alt="">
  </b-modal>

  <!-- Hero Start -->
    <section class="bg-half bg-light d-table w-100">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12 text-center">
                    <div class="page-next-level">
                        <h4 class="title"> 资讯中心 </h4>
                        <div class="page-next">
                            <nav aria-label="breadcrumb" class="d-inline-block">
                                <ul class="breadcrumb bg-white rounded shadow mb-0">
                                    <li class="breadcrumb-item"> <router-link to="/">首页</router-link> </li>
                                    <li class="breadcrumb-item active" aria-current="page">资讯中心</li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <!--end col-->
            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section-->
    <div class="position-relative">
        <div class="shape overflow-hidden text-white">
            <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
            </svg>
        </div>
    </div>
    <!-- Hero End -->

    <!--Blog Lists Start-->
    <section class="section">
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6">
                                <img src="images/work/14.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 21th July, 2022</small>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6">
                                <div class="card-body content">
                                    <h5><a href="#" @click.prevent="onPay" class="card-title title text-dark">Photoshop插件的打包和发布 (1元/篇)</a></h5>
                                    <p class="text-muted mb-0">这篇文章介绍当插件完成开发和测试之后，如何进行打包、生成可安装程序交付到用户的手中。</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>33</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>02</a></li>
                                        </ul>
                                        <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6 order-2 order-md-1">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">JSX的工程化  (1元/篇)</a></h5>
                                    <p class="text-muted mb-0">这篇文章主要介绍JSX的工程化，和上篇结合起来，整个插件的开发工程化就全部完整了。</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>37</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>04</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6 order-1 order-md-2">
                                <img src="images/work/15.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 8th July, 2022</small>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6">
                                <img src="images/work/16.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 24th May, 2022</small>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">前端框架在插件面板中的应用 (1元/篇)</a></h5>
                                    <p class="text-muted mb-0">这篇文章给大家介绍前端的流行框架，如何应用到Photoshop插件面板中，提升我们面板界面开发效率。</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>45</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>05</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6 order-2 order-md-1">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">数据存储相关 (1元/篇) </a></h5>
                                    <p class="text-muted mb-0">这篇文章就来介绍一下CEP插件体系给我们提供了哪些可以进行数据存储的类型和使用方式。</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>48</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>04</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6  order-1 order-md-2">
                                <img src="images/work/17.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 1th Apr, 2022</small>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6">
                                <img src="images/work/18.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 17th Mar, 2022</small>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">nodejs在插件开发中的应用 (1元/篇) </a></h5>
                                    <p class="text-muted mb-0">这篇文章介绍如何在CEP插件面板中使用nodejs，以及一些特性的应用</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>55</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>07</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6 order-2 order-md-1">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">如何从Ps中导出图片 (1元/篇)  </a></h5>
                                    <p class="text-muted mb-0">本篇文章我们就主要介绍如何从Ps中获取图像，或许各种格式的图像</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>61</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>08</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6 order-1 order-md-2">
                                <img src="images/work/19.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 28th Feb., 2022</small>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

                <div class="col-lg-6 col-12 mb-4 pb-2">
                    <div class="card blog rounded border-0 shadow overflow-hidden">
                        <div class="row align-items-center no-gutters">
                            <div class="col-md-6">
                                <img src="images/work/13.jpg" class="img-fluid" alt="">
                                <div class="overlay bg-dark"></div>
                                <div class="author">
                                    <small class="text-light user d-block"><i class="mdi mdi-account"></i> xiaoqiang</small>
                                    <small class="text-light date"><i class="mdi mdi-calendar-check"></i> 15th Jan., 2022</small>
                                </div>
                            </div>
                            <!--end col-->

                            <div class="col-md-6">
                                <div class="card-body content">
                                    <h5><a href="javascript:void(0)" @click.prevent="onPay" class="card-title title text-dark">图层处理那些事(1元/篇) </a></h5>
                                    <p class="text-muted mb-0">介绍Ps中最重要的一块 – 图层的常见操作</p>
                                    <div class="post-meta d-flex justify-content-between mt-3">
                                        <ul class="list-unstyled mb-0">
                                            <li class="list-inline-item mr-2 mb-0"><a href="javascript:void(0)" class="text-muted like"><i class="mdi mdi-heart-outline mr-1"></i>66</a></li>
                                            <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i class="mdi mdi-comment-outline mr-1"></i>05</a></li>
                                        </ul>
                                      <a href="#" @click.prevent="onPay" class="text-muted readmore">阅读更多 <i class="mdi mdi-chevron-right"></i></a>
                                    </div>
                                </div>
                            </div>
                            <!--end col-->
                        </div>
                        <!--end row-->
                    </div>
                    <!--end blog post-->
                </div>
                <!--end col-->

            </div>
            <!--end row-->
        </div>
        <!--end container-->
    </section>
    <!--end section -->
    <!--Blog Lists End-->
    <!--end section-->
    <Footer />
    <!-- Footer End -->
    <Switcher />
    <!-- Back to top -->
    <a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" v-scroll-to="'#topnav'">
        <arrow-up-icon class="icons"></arrow-up-icon>
    </a>
    <!-- Back to top -->
</div>
</template>
